"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlFullBetAdjuster = void 0;
require("./HtmlFullBetAdjuster.scss");
var _core = require("@dragon/core");
var _bet_minus = _interopRequireDefault(require("./bet_minus.svg"));
var _bet_plus = _interopRequireDefault(require("./bet_plus.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Note, this only works with fixed line and coins games, it will show incorrect for games that actually support others and somehow gets it set.
 * Forexample a freespin/ft with less than 10 lines in NoD.
 */
var HtmlFullBetAdjuster = exports.HtmlFullBetAdjuster = /*#__PURE__*/_createClass(function HtmlFullBetAdjuster(parent, classes, id, headerText) {
  var _this = this;
  _classCallCheck(this, HtmlFullBetAdjuster);
  _defineProperty(this, "_node", void 0);
  _defineProperty(this, "_id", void 0);
  _defineProperty(this, "_value", void 0);
  _defineProperty(this, "set", void 0);
  _defineProperty(this, "_values", []);
  _defineProperty(this, "_denominations", []);
  _defineProperty(this, "_enabled", void 0);
  _defineProperty(this, "minus", void 0);
  _defineProperty(this, "plus", void 0);
  _defineProperty(this, "_innerWrapper", void 0);
  _defineProperty(this, "_valueBaseClass", "value");
  _defineProperty(this, "disable", function () {
    _this._enabled = false;
    _this._innerWrapper.classList.add("disabled");
  });
  _defineProperty(this, "enable", function () {
    _this._enabled = true;
    _this._innerWrapper.classList.add("remove");
  });
  _defineProperty(this, "onDenominationChange", function (e) {
    if (_this.set) {
      var state = _core.CORE.getState();
      // +2 to for the buffer
      var index = state.bet.denominations.indexOf(e);
      if (index < 0) return;
      for (var i = 0; i < _this._values.length; i++) {
        _this._values[i].className = _this._valueBaseClass + " hidden";
      }

      // SUPER HACKY WE WILL NEED TO RESOLVE MUST BE A BETTER WAY

      if (index == 0) {
        _this._values[(index + 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 2 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 3 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 4 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
      } else if (index == 1) {
        _this._values[(index - 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 2 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 3 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
      } else if (index + 1 == _this._values.length) {
        _this._values[(index - 4 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index - 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index - 2 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index - 3 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
      } else if (index + 1 == _this._values.length - 1) {
        _this._values[(index + 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index - 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index - 2 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index - 3 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
      } else if (index >= 2 && index <= _this._values.length - 2) {
        _this._values[(index - 2 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index - 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 1 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
        _this._values[(index + 2 + _this._values.length) % _this._values.length].className = _this._valueBaseClass;
      }
      _this._values[index].className = _this._valueBaseClass + " active";
    }
  });
  _defineProperty(this, "click", function (e) {
    if (!_this._enabled) return;
    var value = e.target.getAttribute("data-index");
    _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));

    //this._value.getAttribute('data-value');

    _core.CORE.dispatch((0, _core.updateBet)({
      denomination: _this._denominations[value]
    }));
  });
  this._id = id;
  this._node = document.createElement("div");
  this._node.className = "pager " + classes;
  parent.appendChild(this._node);
  this._innerWrapper = document.createElement("div");
  this._innerWrapper.className = "pagination";
  this._node.appendChild(this._innerWrapper);
  var shaderLeft = document.createElement("div");
  shaderLeft.className = "shader left";
  this.minus = document.createElement("span");
  this.minus.className = "btn betMinus btn_minus hShrink";
  this.minus.onclick = function () {
    _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));
    _core.CORE.dispatch({
      type: _core.DENOM_MINUS
    });
  };
  this.minus.innerHTML = _bet_minus["default"];
  var shaderRight = document.createElement("div");
  shaderRight.className = "shader right";
  this.plus = document.createElement("span");
  this.plus.className = "btn betPlus btn_plus hShrink";
  this.plus.innerHTML = _bet_plus["default"];
  this.plus.onclick = function () {
    _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));
    _core.CORE.dispatch({
      type: _core.DENOM_PLUS
    });
  };
  var valueWrapper = document.createElement("span");
  valueWrapper.className = "valueWrapper";
  this._innerWrapper.appendChild(valueWrapper);

  // This is a bit of ahack, we need to make sure we get both values in state before we can do anything.
  var build = function build() {
    var state = _core.CORE.getState();
    if (state.bet.denomination && state.balance.currency) {
      //Handle currency with big big numbers
      if (["IDR", "VND", "UBT"].indexOf(state.balance.currency) > -1) _this._valueBaseClass = "value small";
      if (["JPY"].indexOf(state.balance.currency) > -1) _this._valueBaseClass = "value medium";
      _this.set = true;
      _this._denominations = state.bet.denominations;
      for (var i = 0; i < _this._values.length; i++) {
        _this._values[i].remove();
      }
      _this._values = [];
      var createValue = function createValue(index, element) {
        var value = document.createElement("span");
        value.className = _this._valueBaseClass + " hidden";

        // If value is greater than 99 we hide the fractions (always 00 anyways...)
        // hiding fractions when not relevant looks weird on smaller numbers
        value.innerHTML = (0, _core.numberFormatter)(state.bet.coins * state.bet.lines * element, state.balance.currency, state.config.locale, state.bet.coins * state.bet.lines * element < 99 ? 2 : 0);
        value.onclick = _this.click;
        value.setAttribute("data-index", index.toString());
        _this._values.push(value);
        valueWrapper.appendChild(value);
      };
      for (var index = 0; index < state.bet.denominations.length; index++) {
        var element = state.bet.denominations[index];
        createValue(index, element);
      }
      _this._innerWrapper.appendChild(shaderLeft);
      _this._innerWrapper.appendChild(shaderRight);
      _this._innerWrapper.appendChild(_this.minus);
      _this._innerWrapper.appendChild(_this.plus);
      if (unsub) unsub();
      _this.onDenominationChange(state.bet.denomination);
    }
  };
  var unsub = _core.CORE.subscribe("balance.currency", build);
  _core.CORE.subscribe("bet.denominations", build);
  _core.CORE.subscribe("bet.denomination", this.onDenominationChange);
  _core.CORE.subscribe("promotion", function (e) {
    if (e && e.on) {
      _this._innerWrapper.classList.add("promotion-active");
    } else {
      _this._innerWrapper.classList.remove("promotion-active");
    }
  });
  _core.CORE.subscribe("bet.betChangeAllowed", function (e) {
    if (e) {
      _this.enable();
    } else {
      _this.disable();
    }
  });
});
//# sourceMappingURL=HtmlFullBetAdjuster.js.map